const dealershipTypes = {
  franchise: 1,
  independent: 2,
  wholesaler: 3,
  acvCertifiedIndependent: 4,
  commercial: 5,
  remarketer: 6,
};

const canSellDealershipTypes = [
  dealershipTypes.franchise,
  dealershipTypes.acvCertifiedIndependent,
  dealershipTypes.commercial,
  dealershipTypes.remarketer,
];

const canSelfRegisterDealershipOptions = [
  {
    description: 'Franchise',
    value: 'franchise',
    id: 1,
  },
  {
    description: 'Independent',
    value: 'independent',
    id: 2,
  },
  {
    description: 'Wholesaler',
    value: 'wholesaler',
    id: 3,
  },
];

export {
  dealershipTypes,
  canSellDealershipTypes,
  canSelfRegisterDealershipOptions,
};
